// extracted by mini-css-extract-plugin
export default {"footer":"Navigation_footer__UBjFU","language":"Navigation_language__c-gdD","footerInfo":"Navigation_footerInfo__bZxR8","footerCredits":"Navigation_footerCredits__yPY7q"};